module.exports = __webpack_public_path__ + "static/media/Keepspace-logo-200-inverted.3df2b0d1.png";